<template>
  <div class="page-container">
    <div class="page-decor">
      <div class="decor-orb orb-1"></div>
      <div class="decor-orb orb-2"></div>
      <div class="decor-line line-1"></div>
      <div class="decor-line line-2"></div>
    </div>

    <section class="page-hero">
      <div class="page-hero-content">
        <div class="page-badge">{{ localize('TERMS_BADGE') }}</div>
        <h1 class="page-title">{{ localize('TERMS_TITLE') }}</h1>
        <p class="page-subtitle">{{ localize('TERMS_SUBTITLE') }}</p>
      </div>
    </section>

    <section class="page-section">
      <div class="section-inner">
        <div class="content-card" v-for="n in 11" :key="n">
          <h2 class="content-heading">{{ localize('TERMS_S' + n + '_TITLE') }}</h2>
          <p class="content-text" v-html="localize('TERMS_S' + n + '_DESC')"></p>
        </div>

        <div class="contact-block">
          <div class="contact-label">Compdeep G.K.</div>
          <div class="contact-detail">{{ localize('TERMS_CONTACT_DEPT') }}</div>
          <div class="contact-detail">legal@compdeep.com</div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

import {translationStore} from "@/stores/translation";

export default {
    "name": "Terms",
    setup () {

        const translation = translationStore();

        return {
            "localize": translation.localize
        };

    }
};

</script>
<style scoped>
.page-container {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}

/* ---- Decorative Elements ---- */
.page-decor {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}
.decor-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  opacity: 0.25;
}
.orb-1 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.2), transparent 70%);
  top: -150px;
  right: -100px;
  animation: drift-1 25s ease-in-out infinite;
}
.orb-2 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(139, 92, 246, 0.15), transparent 70%);
  bottom: 10%;
  left: -100px;
  animation: drift-2 30s ease-in-out infinite;
}
.decor-line {
  position: absolute;
  background: linear-gradient(180deg, transparent, var(--border-subtle), transparent);
  opacity: 0.4;
}
.line-1 {
  width: 1px;
  height: 60%;
  top: 10%;
  left: 15%;
}
.line-2 {
  width: 1px;
  height: 50%;
  top: 20%;
  right: 20%;
}
@keyframes drift-1 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-40px, 60px); }
}
@keyframes drift-2 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(50px, -40px); }
}

/* ---- Hero ---- */
.page-hero {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  padding: 60px 20px 40px;
  text-align: center;
}
.page-hero-content {
  max-width: 700px;
}
.page-badge {
  display: inline-block;
  padding: 8px 20px;
  margin-bottom: 24px;
  font-size: 0.7em;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--accent-blue);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 50px;
  background: rgba(59, 130, 246, 0.08);
}
.page-title {
  font-family: var(--font-heading);
  font-size: 2.2em;
  line-height: 1.2;
  margin: 0 0 20px;
  color: var(--text-primary);
  letter-spacing: 1px;
}
.page-subtitle {
  font-size: 1.05em;
  line-height: 1.7;
  color: var(--text-secondary);
  margin: 0;
}

/* ---- Content ---- */
.page-section {
  position: relative;
  z-index: 1;
  padding: 0 20px 120px;
}
.section-inner {
  max-width: 800px;
  margin: 0 auto;
}
.content-card {
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-radius: 16px;
  padding: 32px 28px;
  margin-bottom: 24px;
}
.content-heading {
  font-family: var(--font-heading);
  font-size: 1.1em;
  color: var(--text-primary);
  margin: 0 0 16px;
  letter-spacing: 0.5px;
}
.content-text {
  font-size: 0.95em;
  color: var(--text-secondary);
  line-height: 1.8;
  margin: 0;
}
.contact-block {
  text-align: center;
  padding: 32px;
  margin-top: 40px;
}
.contact-label {
  font-family: var(--font-heading);
  font-size: 1em;
  color: var(--text-primary);
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}
.contact-detail {
  font-size: 0.9em;
  color: var(--text-muted);
  margin-bottom: 4px;
}

@media (max-width: 750px) {
  .page-title { font-size: 1.6em; }
  .content-card { padding: 24px 20px; }
}
</style>
